<template>
  <div>
    <iframe id="documentFrame" :src="documentUrl" :style="{ height: backgroundCardHeight + 'px', width: backgroundCardWidth + 'px'}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>

    <div v-show="!onlyContent" class="fab_direction-up__three-items">
      <div class="float-btn-group">
        <button class="btn-float btn-triger school-primary_gradient glow-effect_primary" @click="openActions">
          <i class="icon feather icon-more-horizontal text-white" />
        </button>
        <div class="btn-list">
          <a class="btn-float dc_dark-purple description glow-effect_dark" @click="backToTopic">
            <span class="descriptiontext">{{ topicName }}</span>
            <i class="icon feather icon-arrow-up text-white"></i>
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="nextTask" @click="next">
            <span class="descriptiontext">NEXT</span>
            <i class="icon feather icon-arrow-right text-white" />
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="prevTask" @click="previous">
            <span class="descriptiontext">PREVIOUS</span>
            <i class="icon feather icon-arrow-left text-white" />
          </a>
        </div>
      </div>
    </div>

    <div class="flex next_btns__container justify-center" v-if="$siteTypeId() != 1">
      <vs-button v-show="$acl.check('Student')" id="completetask-btn" class="vs-con-loading__container next_btns clickbuttonactive" 
      ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
      @click="completedNowProceed">
      Complete
      </vs-button>
    </div>
    

  </div>
</template>

<script>
import { uuid } from 'vue-uuid';
export default {
  data() {
    return {
      queue: [],
      uuid: "",
      logData: {},
      fabElement: null,
      document: {},
      documentUrl: "",
      onlyContent : false,
      backgroundCardHeight: 0,
      backgroundCardWidth: 0,
      standaloneContentDto: {},
      selectedData: {},
      topicName: '',
      index: null,
      currentTask: null,
      nextTask: null,
      prevTask: null,
      navigateByChoice: false,
      isTeacher: false,
      moduleId: 0,
      isStudentLocal: false
    };
  },
  methods: {
    backToTopic() {
      var self = this;
      self.navigateByChoice = false;
      if (self.$route.query.ref == "resources") {
        if (self.isTeacher) {
          self.$router.push({ name: 'TeacherResources'});
        } else if (self.isStudentLocal) {
          self.$router.push({ name: 'StudentAdditionalResources'})
        }
      } else {
        if(self.selectedData.selectedTopic && self.isTeacher)
          self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else if(self.selectedData.selectedTopic && self.isStudentLocal)
          self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else
          self.$router.push({ name: 'StudentRoster'});
      }
    },
    completedNowProceed(){
      var self = this;
      if (self.$acl.check('Student')) {
        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = null;
        self.logData.taskId = self.$route.query.id;
        self.logData.toTaskId = null;
        
        var onSuccess = function () {
          setTimeout(() => {
            self.$router.push({ name: "LearningStyleBViewer", params: { moduleId: self.moduleId}});
	        }, 69);
        };
        self.$ajaxPost(self, "DocumentTask/EndLogEntry", self.logData, onSuccess);
      } else {
        self.$router.push({ name: "LearningStyleBViewer", params: { moduleId: self.moduleId}});
      }
    },
    next() {
      var self = this;
      self.url = "";
      self.index += 1;

      var data = {
        selectedData: self.selectedData,
        standaloneContentDto: self.standaloneContentDto,
        index: self.index
      }

      localStorage.setItem("lastKnownTopic", JSON.stringify(data));

      if(self.nextTask) {
        self.closeActions();

        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.toTaskId = self.nextTask.id;
        if(self.$route.params.styleB){
          var onSuccess = response => {
            this.backToTopic();
          }
          this.$ajaxPost(self,"DocumentTask/EndLogEntry", self.logData, onSuccess)
        }
        else{
          self.enqueue("DocumentTask/EndLogEntry", self.logData);
        }
        

        self.currentTask = self.nextTask;
        
        self.uuid = self.$uuid.v4();
        self.logData.taskId = self.currentTask.id;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;

        self.nextTask = self.index + 1 <= self.standaloneContentDto.tasks.length ? self.standaloneContentDto.tasks[self.index + 1] : null;
        self.prevTask = self.standaloneContentDto.tasks[self.index - 1];

        self.logData.fromTaskId = (self.prevTask ? self.prevTask.id : null);

        if(self.currentTask.document && self.currentTask.document.id) {
          if(!self.isUserPremium && !self.currentTask.isPremium)
          {
            self.navigateByChoice = false;
            self.document = self.currentTask.document;
            self.showDocument();

            self.enqueue("DocumentTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
          {
            self.navigateByChoice = false;
            self.document = self.currentTask.document;
            self.showDocument();

            self.enqueue("DocumentTask/StartLogEntry", self.logData);
          }
          else
          {
            self.showPremiumContentPopup();
          }
        }
        else if(self.currentTask.video && self.currentTask.video.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if(self.currentTask.podcast && self.currentTask.podcast.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PodcastViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "LiveStreamViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoChatPage",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.upload && self.currentTask.upload.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "UploadViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.presentation && self.currentTask.presentation.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PresentationViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
      }
    },
    previous() {
      var self = this;
      self.url = "";
      self.index = --self.index;
      
      var data = {
        selectedData: self.selectedData,
        standaloneContentDto: self.standaloneContentDto,
        index: self.index
      }

      localStorage.setItem("lastKnownTopic", JSON.stringify(data));
      
      if(self.prevTask) {
        self.closeActions();

        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.toTaskId = self.prevTask.id;
        self.enqueue("DocumentTask/EndLogEntry", self.logData);

        self.currentTask = self.prevTask;

        self.uuid = self.$uuid.v4();
        self.logData.taskId = self.currentTask.id;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;

        self.nextTask = self.standaloneContentDto.tasks[self.index + 1];
        self.prevTask = self.index > 0 ? self.standaloneContentDto.tasks[self.index - 1] : null;

        self.logData.fromTaskId = (self.nextTask ? self.nextTask.id : null);

        if(self.currentTask.document && self.currentTask.document.id) {
          if(!self.isUserPremium  && !self.currentTask.isPremium)
          {
            self.navigateByChoice = false;
            self.document = self.currentTask.document;
            self.showDocument();

            self.enqueue("DocumentTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
          {
            self.navigateByChoice = false;
            self.document = self.currentTask.document;
            self.showDocument();

            self.enqueue("DocumentTask/StartLogEntry", self.logData);
          }
          else
          {
            self.showPremiumContentPopup();
          }
        }
        else if(self.currentTask.video && self.currentTask.video.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if(self.currentTask.podcast && self.currentTask.podcast.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PodcastViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "LiveStreamViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoChatPage",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if (self.currentTask.upload && self.currentTask.upload.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "UploadViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if (self.currentTask.presentation && self.currentTask.presentation.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PresentationViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
      }
    },
    showDocument() {
      var self = this;
      self.documentUrl = self.document.url;
    },
    resizeCard() {
      this.backgroundCardWidth = window.innerWidth * 0.966;
      this.backgroundCardHeight = window.innerHeight * 0.755;

      if(this.vimeoPlayer) {
        this.vimeoPlayer.element.height = this.backgroundCardHeight;
        this.vimeoPlayer.element.width = this.backgroundCardWidth;
      }
    },
    openActions(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle('open')
      }
    },
    closeActions() {
      if (this.fabElement) {
        this.fabElement.classList.remove('open')
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    enqueue(messageType, logPayload) {
      this.queue.push({
        type: messageType,
        payload: {
          logIdentifier: logPayload.logIdentifier.toString(),
          toTaskId: logPayload.toTaskId,
          fromTaskId: logPayload.fromTaskId,
          taskId: logPayload.taskId,
        }
      })
    },
    dequeue() {
      return this.queue.shift();
    },
    startProcessor() {
      var self = this;
      var onSuccess = function (response) {
        var next = self.dequeue();
        if (next)
          self.process(next, onSuccess);
      };
      setInterval(function () {
        if (self.queue.length > 0) {
          self.process(self.dequeue(), onSuccess)
        }
      }, 3000)
    },
    process(queueItem, successFunc) {
      var self = this;
      if (queueItem) {
        self.$ajaxPost(self, queueItem.type, queueItem.payload, function(response){
          successFunc();
        });
      }
    },
  },
  beforeDestroy() {
    var self = this;

    if(!self.navigateByChoice) {
      self.logData.logIdentifier = self.uuid;
      self.logData.fromTaskId = self.currentTask.id;
      self.logData.taskId = self.currentTask.id;
      self.logData.toTaskId = null;
      self.enqueue("DocumentTask/EndLogEntry", self.logData);
    }
  },
  mounted() {
    var self = this;
    self.$store.dispatch("updateTheme", "dark");
    self.startProcessor();
    self.resizeCard();
    self.$nextTick(() => {
      window.addEventListener('resize', () => {
        self.resizeCard();
      });
    });

    self.isTeacher = self.$acl.check("Teacher");

    self.isStudentLocal = self.$acl.check("Student");

    if (Object.keys(self.$route.query).length != 0 && Object.keys(this.$route.params).length == 0) {
      if(self.$route.query.id){
        self.moduleId = self.$route.query.moduleId;
        localStorage.setItem("moduleId", self.moduleId);

        if(!localStorage.getItem("userInfo")) {
          document.cookie = "autoRedirect="+ JSON.stringify({url: "DocumentViewer", id: self.$route.query.id});
          window.location.replace("/login");
        }

        var success = (res) => {
          self.onlyContent = true;
          self.document = {};  
          self.document.url = res.data.documentUrl; 
          self.uuid = self.$uuid.v4();

          self.showDocument();
          self.logData.taskId = self.$route.query.id;
          localStorage.setItem("tid", self.$route.query.id);
          self.logData.logIdentifier = self.uuid;
          self.logData.toTaskId = null;
          self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
          if(self.moduleId)
            self.enqueue("DocumentTask/StartLogEntry", self.logData);
        };

        try{
          self.$ajaxGet(self, "DocumentTask/GetDocumentByTaskId/" + self.$route.query.id, success);
        } catch{} 
      }
    }
    else {
      if(Object.keys(this.$route.params).length != 0){
        self.index = self.$route.params.index;

        self.currentTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0];

        self.document = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0].document;

        if (self.$route.params.standaloneContent.tasks.length > self.index + 1)
          self.nextTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index + 1) })[0];

        if (self.index > 0)
          self.prevTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index - 1) })[0];

        self.standaloneContentDto = self.$route.params.standaloneContent;
        if(self.$route.params.selectedData)
          self.selectedData = self.$route.params.selectedData;

        var data = {
          selectedData: self.selectedData,
          standaloneContentDto: self.standaloneContentDto,
          index: self.index
        }

        localStorage.setItem("lastKnownTopic", JSON.stringify(data));

        if(self.selectedData.selectedTopic)
          self.topicName = self.selectedData.selectedTopic.name;
        else
          self.topicName = "Back to My Roster";

        self.showDocument();

        self.uuid = self.$uuid.v4();
        self.logData.taskId = self.currentTask.id;
        localStorage.setItem("tid", self.currentTask.id);
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;
        self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
        self.enqueue("DocumentTask/StartLogEntry", self.logData);
      }
      else {
        if (self.isStudentLocal) {
          self.$router.push({ name: 'StudentRoster' });
        }
        else {
          self.$router.push({ name: 'BrowseContent' });
        }
      }
    }
  }
};
</script>

<style lang="scss">

.next_btns__container {
  .next_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 100% !important;
  }

  #nexttask-btn {
    width: 13% !important;
    border-radius: 25px !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }

  #completetask-btn {
    z-index: 1000;
    width: 13% !important;
    border-radius: 25px !important;
    background-image: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  }

  @media screen and (max-width: 900px) {
    #nexttask-btn {
      width: 45% !important;
    }

    #completetask-btn {
      width: 45% !important;
    }
  }

  @media screen and (max-width: 700px) {
    #nexttask-btn {
      width: 50% !important;
    }

    #completetask-btn {
      width: 50% !important;
    }
  }
}

  .contentCards {
    margin: auto;
  }

  .fab_direction-up__three-items {
    right: 5vw;
    bottom: 4vh;
    z-index: 999;
    position: fixed;
  }

  // .button-center-bottom{
  //   position:relative !important;
  //   top:100% !important;
  //   width:260px !important;
  //   background: rgb(43,55,43) !important;
  //   background: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  //   &:hover{
  //     cursor: pointer;
  //   }
  // }

</style>
